module.exports = __webpack_public_path__ + "static/media/BackgroundRegister.96937576.png";